export const AddOn_EntityFilter = {
    key: 'entity',
    methodName: 'getEntityKey',
    resultFilter: (entities, result) => {
        return { pass: entities.includes(result.filterResults['entity'].value) };
    },
    isActive: (entities) => !!entities?.length,
    label: 'Entity Type',
    group: 'Properties',
};
//# sourceMappingURL=types.js.map